/** GTIN-8/12/13/14 (EAN-8, UPC-A, EAN-13, GTIN-14) Prüfziffern-Validierung nach GS1. */
export function isValidGtin(value: string): boolean {
  if (!/^\d+$/.test(value)) return false;
  if (![8, 12, 13, 14].includes(value.length)) return false;
  const digits = value.split("").map(Number);
  const check = digits.pop()!;
  let sum = 0;
  // Von rechts: Gewichtung 3,1,3,1,...
  for (let i = digits.length - 1, w = 3; i >= 0; i--, w = w === 3 ? 1 : 3) {
    sum += digits[i]! * w;
  }
  return (10 - (sum % 10)) % 10 === check;
}

/**
 * GS1-Präfixe 020–029 und 200–299 sind für interne/restriktive Nummern vorgesehen
 * (z. B. Gewichtsartikel im Handel). Im Fulfillment oft ein Hinweis auf selbst vergebene Codes.
 */
export function isRestrictedGtin(value: string): boolean {
  const gtin13 = value.length === 12 ? `0${value}` : value;
  if (gtin13.length !== 13) return false;
  return gtin13.startsWith("02") || gtin13.startsWith("2");
}
